import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()

export class BoSpinnerService {
  private defaultTimeout = {
    showAfter: 1000,
    showAtLeast: 1000
  }
  private doneData: boolean = false;
  private doneAtLeast: boolean = false;
  private ignoreShowAfter: boolean = false;
  private lockSpinner: boolean = false;

  constructor(private _spinner: NgxSpinnerService) { }
  public show(isLater?: boolean) {
    if (isLater) {
      return this.showLater();
    }
    return this.showImediate();
  }
  private showLater() {
    this.doneAtLeast = false;
    this.doneData = false;
    this.ignoreShowAfter = false;
    setTimeout(() => {
      if (this.ignoreShowAfter) {
        return this._spinner.hide();
      }
      this._spinner.show();
      setTimeout(() => {
        this.doneAtLeast = true;
        if (this.doneData) {
          this._spinner.hide();
        }
      }, this.defaultTimeout.showAtLeast);
    }, this.defaultTimeout.showAfter);
  }
  private showImediate() {
    this.doneAtLeast = true;
    this.doneData = false;
    this._spinner.show();
  }
  public hide() {
    if (this.lockSpinner) {
      return;
    }

    this.doneData = true;
    this.ignoreShowAfter = true;
    if (this.doneAtLeast) {
      this._spinner.hide();
    }
  }

  public showAndLock() {
    this.lockSpinner = true;
    this._spinner.show();
  }

  public hideAndUnlock() {
    this.lockSpinner = false;
    this._spinner.hide();
  }
}